export default __webpack_public_path__ + "static/media/case-study-9-armoured-vehicle-readiness.3920dc94.mp4";